import React, { Fragment, useEffect, useState } from "react";
import {Button, Ref, Table} from "semantic-ui-react";
import moment from "moment";
import styles from "./DartsScoringTimelines.module.scss";
import {removeNameSeparator} from "../../../../helpers/playersNames.helper";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import IDartsScoringTimeline from "./DartsScoringTimelines.types";
import { doubleAttempt } from "../../../../pages/Darts/Scoring/DartsScoring.thunk";
import { DartsGameType } from "../../../../common/types/DartsGameTypes";
import { IDoubleAttemptPayload } from "../../../../pages/Darts/Scoring/DartsScoring.types";


const DartsScoringTimelines: React.FC = React.memo(() => {
    const dispatch = useAppDispatch();
    const { gameId } = useAppSelector(state => state.DartsScoring.game)
    const dartsCurrentScore = useAppSelector(state => state.DartsScoring.game)
    const {timeline} = dartsCurrentScore;
    const [infoLogs, setInfoLogs] = useState<null | IDartsScoringTimeline[] | undefined>(null);
    const refs = timeline?.reduce((acc: any, value, i) => {
        acc[i] = React.createRef();
        return acc;
    }, {});

    const scrollToElement = (index: number) => {
        if (refs[index].current) {
            refs[index].current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    const reversTimeLine = (logs: any) => {
        const reverseLogs = logs.concat();
        return setInfoLogs(reverseLogs.reverse());
    };
    useEffect(() => {
        if (timeline?.length) {
            scrollToElement(0);
            reversTimeLine(timeline);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeline]);

    //useEffect(() => {
    //    if (containerRef.current) {
    //        containerRef.current.scrollTop = 0;
    //    }
    //}, []);
    // * return (
    //<div className="table-container" ref={containerRef}>
    //  <Table celled>
    //    <thead>

    /** ���
     * @param gameId �����
     * @param throwId ����
     * @returns �����
     */
    const doubleAttemptRequest = (gameId: number, throwId: number) => {
        const doubleAttemptBody: IDoubleAttemptPayload = {
                date: moment().utc().toDate(),
                gameId,
                throwId,
                gameType:DartsGameType.TEST,
            }
        dispatch(doubleAttempt(doubleAttemptBody));
    };

    /**
     * ��� ��� ��
     * @param doubleAttemption �����
     * @returns �����
     */
    const genDoubleAttemptionBtn = (doubleAttemption: number | null, throwId: number) => {
        if (doubleAttemption) {
            return (
                <Button color="green" active onClick={() => doubleAttemptRequest(gameId, throwId)} >
                    {`Double Attempt ${doubleAttemption}`}
                </Button>
            );
        }
        if (doubleAttemption === 0) {
            return (
                <Button color="grey" active content="Double Attempt" onClick={() => doubleAttemptRequest(gameId, throwId)} />
            );
        } else {
            return null;
        }
    };

    const generateBack = (lineDetail: IDartsScoringTimeline) => {
        if (lineDetail.playerIndex === 0 && lineDetail.isThrow) {
            return "lightblue";
        }
        if (lineDetail.playerIndex === 1 && lineDetail.isThrow) {
            return "#f4b084";
        } else {
            return "black";
        }
    };

    return (
        <Table inverted className={styles.timeline_table}>
            <Table.Header className={styles.timeline_table_header}>
                <Table.Row className={styles.timeline_table_header}>
                    <Table.HeaderCell className={styles.timeline_table_header}>Leg</Table.HeaderCell>
                    <Table.HeaderCell className={styles.timeline_table_header}>Player</Table.HeaderCell>
                    <Table.HeaderCell className={styles.timeline_table_header}>DartScore</Table.HeaderCell>
                    <Table.HeaderCell className={styles.timeline_table_header}>Description</Table.HeaderCell>
                    <Table.HeaderCell className={styles.timeline_table_header}></Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Fragment>
                    {infoLogs?.map((line, i) => {
                        return (
                            <Ref innerRef={refs[i]} key={i}>
                                <Table.Row key={i} style={{ background: generateBack(infoLogs[i]), color: line.isThrow ? "black" : "white" }}>
                                    <Table.Cell>{line.leg}</Table.Cell>
                                    <Table.Cell>{removeNameSeparator(line.player)}</Table.Cell>
                                    <Table.Cell>{line.score === null ? "" : line.score}</Table.Cell>
                                    <Table.Cell>{line.description}</Table.Cell>
                                    <Table.Cell>{genDoubleAttemptionBtn(line.doubleAttempt, line.id)}</Table.Cell>
                                </Table.Row>
                            </Ref>
                        );
                    })}
                </Fragment>
            </Table.Body>
        </Table>
    );
})

export default DartsScoringTimelines;